module.exports = __webpack_public_path__ + "static/media/Unsplash_Symbol.ba07b64d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Unsplash_Symbol.svg
// module id = 1605
// module chunks = 17